import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from './app.config';

@Injectable({
  providedIn: 'root'
})
export class AuditLogService {

  constructor(
    private httpClient: HttpClient,
    private apiUrl: AppConfig
  ) {}

  public fetchAuditLogs = (action: string, model: any, paginatedLogsData: any, timeRangeFilter: any): Observable<any> => {
    let params = `?action=${action}`;
    if (model && Object.keys(model).length > 0) {
      params += `&model=${Object.values(model).join('')}`;
    }
    params += `&page_no=${paginatedLogsData.page_no}&page_size=${paginatedLogsData.page_size}&time_range=${encodeURIComponent(timeRangeFilter)}`;
    const url = this.apiUrl.logsTable.search + params;
    return this.httpClient.get<any>(url);
  }

  public searchLogs(action: string, model: any, query: string, searchType: string, paginatedLogsData: any, timeRangeFilter: any): Observable<any> {
    let params = `?action=${action}`;
    if (model && Object.keys(model).length > 0) {
      params += `&model=${Object.values(model).join('')}`;
    }
    params += `&page_no=${paginatedLogsData.page_no}&page_size=${paginatedLogsData.page_size}&time_range=${encodeURIComponent(timeRangeFilter)}`;
    const url = this.apiUrl.logsTable.search + params + `&${searchType}=${encodeURIComponent(query)}`;
    return this.httpClient.get<any>(url);
  }

  public searchBookingLogs(query: string): Observable<any> {
    const url = `${this.apiUrl.logsTable.booking}?booking_id=${encodeURIComponent(query)}`;
    return this.httpClient.get<any>(url);
  }

  public searchById(query: string, action: string): Observable<any> {
    const url = `${this.apiUrl.logsTable.myList}?object_id=${encodeURIComponent(query)}&model=${encodeURIComponent(action)}`;
    return this.httpClient.get<any>(url);
  }
}
